import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { CreditCard } from "lucide-react";

export default function AdminPayments() {
  const [payments, setPayments] = useState([]);
  useEffect(() => { (async () => { try { const { data } = await api.get("/admin/payments"); setPayments(data); } catch {} })(); }, []);
  const total = payments.reduce((s, p) => s + (p.amount || 0), 0);

  return (
    <div>
      <h1 className="font-head font-black text-4xl tracking-tighter mb-1 flex items-center gap-2"><CreditCard className="w-7 h-7" /> Payments</h1>
      <p className="text-gray-600 font-medium mb-6">All transactions via Authorize.Net.</p>
      <div className="bg-[#10B981] text-white nb-border nb-shadow p-5 mb-6 inline-block">
        <div className="font-head font-bold uppercase text-xs">Total Revenue</div>
        <div className="font-head font-black text-3xl">${total.toFixed(2)}</div>
      </div>
      <div className="bg-white nb-border nb-shadow overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="bg-[#F3F3F1] nb-border border-x-0 border-t-0 font-head font-bold uppercase text-xs">
            <th className="text-left p-3">User</th><th className="text-left p-3">Plan</th><th className="text-left p-3">Txn ID</th><th className="text-left p-3">Date</th><th className="text-right p-3">Amount</th>
          </tr></thead>
          <tbody>
            {payments.map((p) => (
              <tr key={p.id} className="nb-border border-x-0 border-t-0" data-testid={`admin-payment-${p.id}`}>
                <td className="p-3"><div className="font-bold">{p.user_name}</div><div className="text-gray-500 text-xs">{p.user_email}</div></td>
                <td className="p-3 font-medium">{p.plan_name}</td>
                <td className="p-3 font-mono text-xs">{p.transaction_id}</td>
                <td className="p-3 text-gray-500 text-xs">{new Date(p.created_at).toLocaleDateString()}</td>
                <td className="p-3 text-right font-head font-black">${p.amount}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {payments.length === 0 && <div className="p-10 text-center text-gray-500 font-medium">No payments yet.</div>}
      </div>
    </div>
  );
}
